import axios from 'axios';
import { translate, getLang } from '../i18n/LanguageContext';
import { saveSessionNotice } from '../utils/kernelDevice';

export const API_URL = process.env.REACT_APP_API_URL || '/api';
export const API_ORIGIN = API_URL.replace(/\/+$/, '').replace(/\/api\/?$/, '');

export const assetUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_ORIGIN}${path.startsWith('/') ? '' : '/'}${path}`;
};

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const newToken = response.headers['x-token'];
    if (newToken) {
      localStorage.setItem('token', newToken);
    }
    return response;
  },
  (error) => {
    const url = error.config?.url || '';
    const isAuthEndpoint =
      url.includes('/auth/login') ||
      url.includes('/auth/register') ||
      url.includes('/auth/forgot-password') ||
      url.includes('/auth/reset-password');

    if (error.response?.status === 401 && !isAuthEndpoint) {
      saveSessionNotice(error.response.data); // se l'accesso è stato chiuso, il login ne spiega il motivo
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const errorMessage = (err, fallback) => {
  const def = translate('errors.communication', getLang());
  return err?.response?.data?.message || err?.response?.data?.error || fallback || def;
};

export default api;
